import {makeAutoObservable} from "mobx";
import {ValidatedValue} from "../../helpers/validatedValue";

export interface IDangerousGoodInStore {
    clearDangerousGood: () => void;
    unCodeId: ValidatedValue<string>;
    setUnCodeId: (unCode: string) => void;
    packingId: ValidatedValue<string>;
    setPackingId: (packing: string) => void;
    packingQuantity: ValidatedValue<number | null>;
    setPackingQuantity: (packingQuantity: number) => void;
    packingGroup: ValidatedValue<string>;
    setPackingGroup: (packingGroup: string) => void;
    weight: ValidatedValue<number | null>;
    setWeight: (dangerousGoodsWeight: number) => void;
}

export class DangerousGoodInStore implements IDangerousGoodInStore {
    _unCodeId: ValidatedValue<string>;
    _packingId: ValidatedValue<string>;
    _packingQuantity: ValidatedValue<number | null>;
    _packingGroup: ValidatedValue<string>;
    _weight: ValidatedValue<number | null>;

    constructor() {
        makeAutoObservable(this);

        this._unCodeId = new ValidatedValue("");
        this._packingId = new ValidatedValue("");
        this._packingQuantity = new ValidatedValue(null);
        this._packingGroup = new ValidatedValue("");
        this._weight = new ValidatedValue(null);
    }

    clearDangerousGood() {
        this._unCodeId.setValue("");
        this._packingId.setValue("");
        this._packingQuantity.setValue(0);
        this._packingGroup.setValue("");
        this._weight.setValue(0);
    }

    get unCodeId() {
        return this._unCodeId;
    }

    setUnCodeId(unCodeId: string) {
        this._unCodeId.setValue(unCodeId);
    }

    get packingId() {
        return this._packingId;
    }

    setPackingId(packingId: string) {
        this._packingId.setValue(packingId);
    }

    get packingQuantity() {
        return this._packingQuantity;
    }

    setPackingQuantity(packingQuantity: number) {
        this._packingQuantity.setValue(packingQuantity);
    }

    get packingGroup() {
        return this._packingGroup;
    }

    setPackingGroup(packingGroup: string) {
        this._packingGroup.setValue(packingGroup);
    }

    get weight() {
        return this._weight;
    }

    setWeight(weight: number) {
        this._weight.setValue(weight);
    }
}
